// Simulation orchestrator. One fixed-timestep call runs every gameplay system
// in a deliberate order. The whole sim pauses while the player owes a decision
// (card choice) or the run has ended (death screen), matching the blueprint's
// "the game stops and offers a choice" beat.

import type { GameState } from '@core/state';
import { updateHarvest } from './harvest';
import { updateProduction } from './production';
import { updatePopulation } from './population';
import { updateBuildings } from './buildings';
import { updateBuffs } from './tech';
import { checkGate } from './ages';
import { updateWaves } from './waves';
import { updateCalamities } from './calamities';

export function updateSim(state: GameState, dt: number): void {
  if (state.pending.cardChoices || state.pending.dead) return;

  state.gameTime += dt;

  updateBuffs(state); // expire timed buffs before they feed production
  updateHarvest(state, dt); // manual: cursor damage circle
  updateProduction(state, dt); // passive: buildings + auto-collect
  updatePopulation(state, dt); // growth + auto-collect unlock
  updateBuildings(state, dt); // spend resources on new buildings
  checkGate(state); // progress summons the era boss (or, in early ages, a free card)
  if (state.pending.cardChoices) return; // free early-age advance opened a choice
  updateWaves(state); // timer-driven combat; a gate-boss win opens the card choice
  if (state.pending.cardChoices || state.pending.dead) return; // decision/death owed
  updateCalamities(state); // random non-war disasters on their own clock
}
